import React, { useState, useEffect, useRef } from 'react';
import { Dimensions, SafeAreaView, ActivityIndicator, StyleSheet, View, Text, ScrollView, TextInput, TouchableOpacity, Alert, Image, Modal, FlatList } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Calendar } from 'react-native-calendars';
import { Linking } from 'react-native';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';
import { LinearGradient } from 'expo-linear-gradient';
import { Animated } from 'react-native';   // already have Animated in the project



const CreateSubmissionPage = ({ route, navigation }) => {

const [countdown, setCountdown] = useState(4);   // 4…3…2…1…0
const canSkip = countdown === 0;          
const timerRef = React.useRef(null);              // holds the interval id

const lastTrackedListingRef = React.useRef(null); // prevents double counting


const IMAGE_BASE = 'https://collabbayadmin.com/listings/';
const FALLBACK_BANNER = 'https://images.pexels.com/photos/1058277/pexels-photo-1058277.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1';

const parseBannerImages = (csv) => {
  if (!csv || !csv.trim()) return [FALLBACK_BANNER];
  const arr = csv
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .map(u => (u.startsWith('http') ? u : IMAGE_BASE + u));
  return arr.length ? arr : [FALLBACK_BANNER];
};


// --- AdvanceDays helpers ---
const pad2 = (n) => (n < 10 ? `0${n}` : `${n}`);
const formatYMD = (d) => `${d.getFullYear()}-${pad2(d.getMonth()+1)}-${pad2(d.getDate())}`;

const buildLocalDateTime = (dateStr, timeLabel) => {
  if (!dateStr || !timeLabel) return null;
  const [y, m, d] = dateStr.split('-').map(Number);
  const [hm, ampm] = timeLabel.split(' ');
  const [hStr, minStr] = hm.split(':');
  let h = parseInt(hStr, 10);
  const minutes = parseInt(minStr, 10);
  if (ampm?.toUpperCase() === 'PM' && h !== 12) h += 12;
  if (ampm?.toUpperCase() === 'AM' && h === 12) h = 0;
  const dt = new Date();
  dt.setFullYear(y, m - 1, d);
  dt.setHours(h, minutes, 0, 0);
  return dt;
};

const computeEarliestAllowedMidnight = (advanceDays) => {
  const base = new Date();
  base.setHours(0, 0, 0, 0);
  base.setDate(base.getDate() + advanceDays);
  return base;
};



const [screenTimePassed, setScreenTimePassed] = useState(false);

useEffect(() => {
  const timer = setTimeout(() => {
    setScreenTimePassed(true);
  }, 5000); // 7 seconds

  return () => clearTimeout(timer); // Clean up
}, []);

  if (
    route.params.ListingID === 'LIST2219ECYF' &&
    typeof window !== 'undefined' &&
    document.referrer === ''
  ) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff', padding: 20 }}>
        <Text style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 20 }}>Content restricted</Text>
        <TouchableOpacity
          onPress={() => window.location.href = 'https://collabbay.com'}
          style={{
            backgroundColor: '#FDF05D',
            paddingVertical: 12,
            paddingHorizontal: 20,
            borderRadius: 8,
            borderWidth: 2,
            borderColor: '#000',
          }}
        >
          <Text style={{ fontSize: 16, fontWeight: 'bold' }}>Head back to Collabbay</Text>
        </TouchableOpacity>
      </View>
    );
  }
  

  const [loadedThumbs, setLoadedThumbs] = useState({});


  const [listingData, setListingData] = useState(null);
  const [logoImage, setLogoImage] = useState('');
  const [userData, setUserData] = useState(null);
  const [collabData, setCollabData] = useState({
    ListingID: '',
    BrandName: '',
    BrandURL: '',
    BrandUserID: '',
    Redeem_Message: '',
    AdHeader: '',
    ListingDescription: '',
    Credits: '',
    CreditAvailableStart: '',
    Message: '',
    PreferredAvailability: '',
    ContentBrief: '',
  });
  
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('1:00 AM');
  const [message, setMessage] = useState('');
  const [bookedSlots, setBookedSlots] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [addedVisitors, setAddedVisitors] = useState(null);


  const [showWarning, setShowWarning] = useState(false);
  const [minFollowersRequired, setMinFollowersRequired] = useState(null);

  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [redirectUrl, setRedirectUrl] = useState('');
  const [engagementEmailData, setEngagementEmailData] = useState(null);

  const [isLoading, setIsLoading] = useState(true);

  const [creatorFirstName, setCreatorFirstName] = useState('');
  const [creatorLastName, setCreatorLastName] = useState('');
  const [creatorPhoneNumber, setCreatorPhoneNumber] = useState('');
  const [additionalDetailsRequired, setAdditionalDetailsRequired] = useState(false);
  
  
// Bartering logic

  const [barterAllowed, setBarterAllowed] = useState(false);
  const [customOfferActive, setCustomOfferActive] = useState(false);
  const [customCredits, setCustomCredits] = useState('');
  const [customNonCreditOffer, setCustomNonCreditOffer] = useState('');
  
  const [isSubmitting, setIsSubmitting] = useState(false);

  
  const [showInfoModal, setShowInfoModal] = useState(false);


  const [bannerLoaded, setBannerLoaded] = useState(false);
const [logoLoaded, setLogoLoaded] = useState(false);


// ➊ quick-feedback modal
const [exitSurveyVisible, setExitSurveyVisible] = useState(false);
const [selectedExitReason, setSelectedExitReason] = useState('');
const exitReasons = [
  { id: 'value_low',   label: 'Too low value' },
  { id: 'too_far',     label: 'Too far' },
  { id: 'venue_closed',label: 'Closed when I’m free' },
  { id: 'not_fan',     label: 'Brand’s not my style' },
  { id: 'other',     label: 'Other' },
];






// --- put this near the other consts ---
const SCREEN_WIDTH = Dimensions.get('window').width;
const MAX_BANNER_WIDTH = 600;
const BANNER_WIDTH = Math.min(SCREEN_WIDTH, MAX_BANNER_WIDTH) * 0.92;
const BANNER_HEIGHT = 208;


const [bannerImages, setBannerImages] = useState([]);
const [bannerIndex, setBannerIndex] = useState(0);
const bannerListRef = useRef(null);


const [venueShots, setVenueShots] = useState([]);
const [shotsModalVisible, setShotsModalVisible] = useState(false);
const [initialSlide, setInitialSlide] = useState(0);


const scaleAnim = useRef(new Animated.Value(0)).current;

useEffect(() => {
  const id = route?.params?.ListingID;
  if (!id) return;

  // ✅ prevent duplicate increments (re-renders / dev strict-mode)
  if (lastTrackedListingRef.current === id) return;
  lastTrackedListingRef.current = id;

  const url = 'https://collabbay.com/APIControllers/TrackListingViews.php';

  const opts = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ ListingID: id }),
  };

  // ✅ helps on web if user navigates away quickly
  if (typeof window !== 'undefined') {
    opts.keepalive = true;
  }

  // fire-and-forget (non-blocking)
  fetch(url, opts).catch(() => {});
}, [route?.params?.ListingID]);


useEffect(() => {
  if (!route.params.ListingID) return;

  fetch(`https://collabbay.com/APIControllers/FetchVenueShots.php?ListingID=${route.params.ListingID}`)
    .then(res => res.json())
    .then(data => {
      if (Array.isArray(data)) {
        const validShots = data.filter(item =>
          item.Image &&
          typeof item.Image === 'string' &&
          item.Image.startsWith('http') &&
          item.Image.match(/\.(png|jpe?g|mp4|mov)$/i)
        );
        setVenueShots(validShots); // ✅ Full list for modal FlatList
      } else {
        setVenueShots([]);
      }
    })
    .catch(() => {
      setVenueShots([]);
    });
}, [route.params.ListingID]);


useEffect(() => {
  if (successModalVisible) {
    scaleAnim.setValue(0);
    Animated.spring(scaleAnim, {
      toValue: 1,
      friction: 5,
      tension: 80,
      useNativeDriver: true,
    }).start();
  }
}, [successModalVisible]);


  const areAllFieldsFilled = () => {
    const isCollabDataFilled = Object.keys(collabData)
      .filter(key => key !== 'Message') // Exclude optional "Message" field
      .every(key => collabData[key] !== '' && collabData[key] !== null);
  
    if (!isCollabDataFilled || !selectedDate || !selectedTime) {
      return false;
    }
  
    if (additionalDetailsRequired) {
      if (!creatorFirstName || !creatorLastName || !creatorPhoneNumber) return false;
    }
  
    return true;
  };
  



  const parsePreferredAvailability = (preferredAvailability) => {
    if (!preferredAvailability) return [];
    return preferredAvailability.split(',').map((block) => block.trim());
  };



  const renderPreferredAvailability = () => {
    const parsedAvailability = parsePreferredAvailability(collabData.PreferredAvailability);
  
    if (parsedAvailability.length === 0) {
      return <Text style={styles.noAvailabilityText}>No availability data provided</Text>;
    }
  
    return (
      <View style={styles.availabilityContainer}>
        <Text style={styles.availabilityHeader}>Booking Availability</Text>
        <View style={styles.availabilityList}>
          {parsedAvailability.map((entry, index) => (
            <View key={index} style={styles.availabilityItem}>
              <Text style={styles.availabilityText}>{entry}</Text>
            </View>
          ))}
        </View>
      </View>
    );
  };
  
  
  const handleBackPress = () => {
    if (screenTimePassed) {
      const shouldShowSurvey = Math.random() < 0.10; // 34% chance
      if (shouldShowSurvey) {
        setExitSurveyVisible(true);
      } else {
        navigation.goBack(); // Skip survey randomly
      }
    } else {
      navigation.goBack(); // Skip survey if under 10s
    }
  };
  
  
  const sendExitSurvey = async (reasonText) => {
    try {
      // optimistic UI – do not block on network
      fetch('https://collabbay.com/APIControllers/CreatorDeclineOfferSurvey.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: userData?.Username,          // make sure you already populate userData elsewhere
          brandName: listingData?.BrandName,
          reason: reasonText,
        }),
      });
    } catch (e) {
      // silently ignore – we still want to leave the page
      console.log('survey error', e);
    } finally {
      setExitSurveyVisible(false);
      navigation.goBack();                      // original back behaviour
    }
  };
  

  useEffect(() => {
    if (exitSurveyVisible) {
      setCountdown(4);
      timerRef.current = setInterval(() => {
        setCountdown(prev => {
          // when we reach 0, just stop the timer – DO NOT close the modal
          if (prev === 1) {
            clearInterval(timerRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      clearInterval(timerRef.current);
    }
  
    // tidy-up if component unmounts
    return () => clearInterval(timerRef.current);
  }, [exitSurveyVisible]);
  
  

  useEffect(() => {
    const checkPromoterVerificationStatus = async () => {
      try {
        const response = await fetch('https://collabbay.com/APIControllers/CheckPromoterVerificationStatus.php', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include' // Ensure cookies are sent to maintain session
        });
        const data = await response.json();
  
        // Only check the status if it exists
        if (data.Status) {
          // Check if data.Status is not 'Public Figure'
          if (data.Status !== 'Public Figure') {
            setShowWarning(true);
          }
        } else {
          console.log('No status found, skipping verification check.');
        }
      } catch (error) {
        console.error('Error fetching promoter verification status:', error);
      }
    };
  
    checkPromoterVerificationStatus();
  }, []);
  

 
  useEffect(() => {
    const fetchListingData = async () => {
      setIsLoading(true); // Start loading before the API call
      try {
        const response = await fetch(`https://collabbay.com/APIControllers/RetrieveOfferDescription.php?ListingID=${route.params.ListingID}`);
        if (!response.ok) {
          throw new Error('Failed to fetch listing data');
        }
        const data = await response.json();
        setListingData(data); // Store the full response in the state
  
// Keep numeric AdvanceDays handy (NULL/'' means no restriction)
const advDays = (data?.AdvanceDays === null || data?.AdvanceDays === '' || isNaN(Number(data?.AdvanceDays)))
  ? null
  : Number(data.AdvanceDays);

        setBannerImages(parseBannerImages(data.LogoImage));
setBannerIndex(0);
setBannerLoaded(false);


        // Populate the form fields with the fetched data
        setAdditionalDetailsRequired(data?.AdditionalBookingDetails === 'Y');
        setMinFollowersRequired(data?.MinFollowersRequired);
        setBarterAllowed(data?.Barter === 'Y');
        setCollabData(prevCollabData => ({
          ...prevCollabData,
          ListingID: route.params.ListingID,
          BrandName: data.BrandName || '',
          BrandURL: data.BrandURL || '',
          BrandUserID: data.BrandUserID || '',
          Redeem_Message: data.Redeem_Message || '',
          AdHeader: data.AdHeader || '',
          ListingDescription: data.ListingDescription || '',
          Credits: data.Credits || '',
          PreferredAvailability: data.PreferredAvailability || '',
          ContentBrief: data.ContentBrief || '',
          LogoImage: data.LogoImage || '',
          Location: data.Location || '',
          MinFollowersRequired: data.MinFollowersRequired || '', // Set MinFollowersRequired field
          NonCreditOffer: data.NonCreditOffer || '', // Set NonCreditOffer field
          TurnAroundDays: data.TurnAroundDays || '',
        }));
      } catch (error) {
        console.error('Error fetching listing data:', error);
      } finally {
        setIsLoading(false); // End loading after the API call
      }
    };
  
    fetchListingData();
  }, [route.params.ListingID]);
  
  
  

  // Fix: fetchBookedSlots function to properly handle the PHP API response and parse date
  useEffect(() => {
    const fetchBookedSlots = async () => {
      try {
        const response = await fetch(`https://collabbay.com/APIControllers/RetrieveBookedTimes.php?ListingID=${route.params.ListingID}`);
        if (!response.ok) {
          throw new Error('Failed to fetch booked slots');
        }
        const data = await response.text(); // Get the plain text response
        const slots = data
          .split('<br>') // Split the data by line breaks
          .map(slot => slot.replace('CreditAvailableStart: ', '').trim()) // Remove the label
          .filter(Boolean); // Remove any empty entries
        setBookedSlots(slots); // Updated to handle the response correctly
      } catch (error) {
        console.error('Error fetching booked slots:', error);
      }
    };

    fetchBookedSlots();
  }, [route.params.ListingID]);


  useEffect(() => {
  if (bannerImages.length <= 1) return;
  const id = setInterval(() => {
    setBannerIndex((prev) => {
      const next = (prev + 1) % bannerImages.length;
      bannerListRef.current?.scrollToOffset({ offset: next * BANNER_WIDTH, animated: true });
      return next;
    });
  }, 2000); // 2 seconds
  return () => clearInterval(id);
}, [bannerImages.length]);





const onBannerScrollEnd = (e) => {
  const x = e?.nativeEvent?.contentOffset?.x || 0;
  const idx = Math.round(x / BANNER_WIDTH);
  if (!Number.isNaN(idx)) setBannerIndex(idx);
};


const scrollTo = (i) => {
  if (!bannerListRef.current || bannerImages.length === 0) return;
  const idx = ((i % bannerImages.length) + bannerImages.length) % bannerImages.length; // wrap
  bannerListRef.current.scrollToOffset({ offset: idx * BANNER_WIDTH, animated: true });
  setBannerIndex(idx);
};
const nextBanner = () => scrollTo(bannerIndex + 1);
const prevBanner = () => scrollTo(bannerIndex - 1);



const handleCloseToCollabbayHome = async () => {
  setSuccessModalVisible(false);

  try {
    if (typeof window !== 'undefined' && window.location) {
      window.location.href = 'https://collabbay.com';
      return;
    }

    await Linking.openURL('https://collabbay.com');
  } catch (error) {
    console.error('Unable to open Collabbay home:', error);
  }
};

const formatOfferForEmail = (nonCreditOffer, credits) => {
  const offerText = typeof nonCreditOffer === 'string' ? nonCreditOffer.trim() : '';
  const rawCredits = credits === null || credits === undefined ? '' : String(credits).trim();

  const valueText = rawCredits
    ? (rawCredits.startsWith('£') ? rawCredits : `£${rawCredits}`)
    : '';

  if (offerText && valueText) {
    return `${offerText} (offer value ${valueText})`;
  }

  if (offerText) {
    return offerText;
  }

  if (valueText) {
    return `the complimentary Collabbay offer (offer value ${valueText})`;
  }

  return 'the complimentary offer shown in the Collabbay listing';
};

const getEmailLaunchErrorMessage = () =>
  'Your booking was sent successfully, but we could not open your email app. You can continue browsing as normal.';

const handleEmailVenue = async () => {
  const data = engagementEmailData;

  if (!data?.eligible || !data?.available || !data?.venueEmail) {
    return;
  }

  const venueEmail = String(data.venueEmail).trim();

  const venueName = String(
    data.venueName || collabData.BrandName || 'venue'
  ).trim();

  const creatorUsername = String(
    data.creatorUsername || ''
  ).trim();

  const creatorDisplayName = String(
    data.creatorDisplayName || creatorUsername || 'the creator'
  ).trim();

  const bookingDateTime = String(
    data.bookingDateTime || `${selectedDate} ${selectedTime}`
  ).trim();

  const partySize =
    Number.isFinite(Number(data.partySize)) && Number(data.partySize) > 0
      ? Number(data.partySize)
      : (Number(addedVisitors || 0) + 1);

  const partyText = `${partySize} ${partySize === 1 ? 'person' : 'people'}`;

  const offer = formatOfferForEmail(
    data.nonCreditOffer,
    data.credits
  );

  const deliverables =
    String(data.contentBrief || '').trim() ||
    'the content outlined in the Collabbay listing';

  const creatorIntro =
    creatorUsername && creatorDisplayName !== creatorUsername
      ? `${creatorDisplayName} (Collabbay username: ${creatorUsername})`
      : creatorDisplayName;

  const signOff =
    creatorUsername && creatorDisplayName !== creatorUsername
      ? `${creatorDisplayName}\n${creatorUsername}`
      : creatorDisplayName;

  const variants = [
    `Hi ${venueName} team,

My name is ${creatorIntro}.

I've just sent a booking request through Collabbay to visit on ${bookingDateTime} for ${partyText}.

The request is for ${offer} in exchange for ${deliverables}.

You can view my profile and previous content on Collabbay. If you're happy to go ahead, you can approve the request there. If the date doesn't work, feel free to suggest another one using the Move option.

Thanks and hope to hear from you.

Best,
${signOff}`,

    `Hi ${venueName} team,

My name is ${creatorIntro}.

Just a quick heads-up that I've submitted a booking request on Collabbay for ${bookingDateTime}, for ${partyText}.

The request is for ${offer} in exchange for ${deliverables}.

You can take a look at my profile and previous content on Collabbay. If you're happy with the request, you can approve it on the platform. If the proposed date isn't convenient, you're also welcome to suggest another one using the Move option.

Thanks very much and hope to hear from you.

Best,
${signOff}`,

    `Hi ${venueName} team,

My name is ${creatorIntro}.

I've just requested a visit through Collabbay for ${bookingDateTime}, for ${partyText}.

The request is for ${offer} in exchange for ${deliverables}.

My profile and previous content are available to view on Collabbay. If everything looks good, you can approve the request there. If the date doesn't work for you, feel free to suggest another date using the Move option.

Thanks, and I hope to hear from you.

Best,
${signOff}`,

    `Hi ${venueName} team,

My name is ${creatorIntro}.

I wanted to let you know I've just sent over a Collabbay booking request for ${bookingDateTime}, for ${partyText}.

The request is for ${offer} in exchange for ${deliverables}.

You can review my profile and previous content on Collabbay. If you're happy to proceed, you can approve the request on the platform. If that date isn't suitable, please feel free to suggest another one using the Move option.

Thanks and hope to hear from you soon.

Best,
${signOff}`
  ];

  const variantIndex = Number.isInteger(data.emailVariantIndex)
    ? data.emailVariantIndex % variants.length
    : Math.floor(Math.random() * variants.length);

  const body = variants[variantIndex];

  const subject =
    `Collab Bay booking request – ${creatorUsername || creatorDisplayName}`;

  const mailtoURL =
    `mailto:${encodeURIComponent(venueEmail)}` +
    `?bcc=${encodeURIComponent('collabbaycloud@gmail.com')}` +
    `&subject=${encodeURIComponent(subject)}` +
    `&body=${encodeURIComponent(body)}`;

  try {
    await Linking.openURL(mailtoURL);
  } catch (error) {
    console.error('Unable to open mail client:', error);

    const errorMessage = getEmailLaunchErrorMessage();

    if (
      typeof window !== 'undefined' &&
      typeof window.alert === 'function'
    ) {
      window.alert(errorMessage);
    } else {
      Alert.alert('Email app unavailable', errorMessage);
    }
  }
};


const handleCollabPress = async () => {
    if (isSubmitting) return; // Prevent double click
    setIsSubmitting(true);    // Lock the button
  
    if (addedVisitors === null) {
      alert('Please select how many additional visitors will attend...');
      setIsSubmitting(false); // Re-enable button
      return;
    }
  

// --- AdvanceDays client check (server also enforces) ---
try {
  const rawAdv = listingData?.AdvanceDays;
  if (rawAdv !== null && rawAdv !== '' && !isNaN(Number(rawAdv))) {
    const adv = Number(rawAdv);
    if (adv > 0) {
      const proposed = buildLocalDateTime(selectedDate, selectedTime);
      if (!proposed) {
        alert('Please select a date and time.');
        setIsSubmitting(false);
        return;
      }
      const earliest = computeEarliestAllowedMidnight(adv);
      if (proposed < earliest) {
        setErrorMessage(`This venue requires at least ${adv} day(s) notice. Earliest you can book is ${formatYMD(earliest)}.`);
        setErrorModalVisible(true);
        setIsSubmitting(false);
        return;
      }
    }
  }
} catch(e) { /* fail open; PHP re-checks */ }


    try {
      const fullDateTime = `${selectedDate} ${selectedTime}`;
      
      const updatedCollabData = {
        ...collabData,
        CreditAvailableStart: fullDateTime,
        Message: message.trim(),
        Credits: customCredits.trim() !== '' ? customCredits.trim() : collabData.Credits,
        NonCreditOffer: customNonCreditOffer.trim() !== '' ? customNonCreditOffer.trim() : collabData.NonCreditOffer,
      };
      
 const postData = {
  ...updatedCollabData,
  AddedVisitors: addedVisitors,
  PointsEarned: listingData?.PointsEarned ?? 0,   // ✅ send to PHP
  ...(additionalDetailsRequired && {
    CreatorFirstName: creatorFirstName.trim(),
    CreatorLastName: creatorLastName.trim(),
    CreatorPhoneNumber: creatorPhoneNumber.trim(),
  }),
};

  
      const response = await fetch('https://collabbay.com/APIControllers/InsertCollabSubmission.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(postData),
      });
  
      const result = await response.json();


if (response.ok && result.success) {
  setRedirectUrl(result.redirectUrl);

  const engagement = result?.engagementEmail;

  const venueEmail =
    typeof engagement?.venueEmail === 'string'
      ? engagement.venueEmail.trim()
      : '';

  const hasUsableVenueEmail =
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(venueEmail);

  if (
    engagement?.eligible === true &&
    engagement?.available === true &&
    hasUsableVenueEmail
  ) {
    setEngagementEmailData({
      ...engagement,
      venueEmail,
      emailVariantIndex: Math.floor(Math.random() * 4),
    });
  } else {
    setEngagementEmailData(null);
  }

  setSuccessModalVisible(true);

} else if (result.error === "Selected date and time do not match the brand's preferred availability.") {
        setErrorMessage('Booking Error. Check that your selected date and time is within the venue\'s opening time.');
        setErrorModalVisible(true);
      } else if (result.message) {
        setErrorMessage('This offer has a minimum follower requirement.');
        setErrorModalVisible(true);
      } else {
        setErrorMessage(result.error || 'An error occurred during submission.');
        setErrorModalVisible(true);
      }
  
    } catch (error) {
      console.error('Submission Error:', error);
      setErrorMessage('An error occurred while submitting the form.');
      setErrorModalVisible(true);
    } finally {
      setIsSubmitting(false); // Unlock the button once complete
    }
  };
  
  
  

  useEffect(() => {
    const fetchLogoImage = async () => {
      try {
        // Use listingData?.BrandName dynamically in the fetch URL
        const response = await fetch(`https://collabbay.com/APIControllers/GetBrandLogoImage.php?BrandName=${listingData?.BrandName}`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch logo image');
        }
  
        const data = await response.json();
  
        if (data.success) {
          // Set the ProfileImage from the response
          setLogoImage(data.ProfileImage);
        } else {
          console.error('Logo image fetch unsuccessful');
        }
      } catch (error) {
        console.error('Error fetching logo image:', error);
      }
    };
  
    // Ensure listingData?.BrandName exists before calling the fetch function
    if (listingData?.BrandName) {
      fetchLogoImage();
    }
  
  }, [listingData?.BrandName]);

  // Render Booked Slots: Update this to echo the correct format
  const renderBookedSlots = () => {
    const displayedSlots = expanded ? bookedSlots : bookedSlots.slice(0, 3);
    





    return (
      <View>
 {bookedSlots.length > 0 && (
  <View
    style={{
      position: 'absolute',
      bottom: 15,
      right: 9,
      backgroundColor: '#FFFBE5',
      borderColor: '#FDF05D',
      borderWidth: 1.5,
      borderRadius: 20,
      paddingVertical: 6,
      paddingHorizontal: 12,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      shadowColor: '#000',
      shadowOpacity: 0.08,
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 4,
      zIndex: 5,
    }}
  >
    <Ionicons name="eye-outline" size={18} color="black" />
    <Text style={{ fontSize: 14, color: '#333' }}>
      <Text style={{ fontWeight: 'bold', fontSize: 18 }}>{bookedSlots.length}</Text> booked recently
    </Text>
  </View>
)}


    </View>
    );
  };

  const renderContentBrief = () => {
    if (collabData.ContentBrief) {
      const contentBriefItems = collabData.ContentBrief.split(',').map(item => item.trim());
      return (
        <View style={styles.contentBriefContainer}>
          <Text style={styles.sectionTitle}>Content Brief</Text>
          {contentBriefItems.map((item, index) => (
            <Text key={index} style={styles.bulletPoint}>• {item}</Text>
          ))}
        </View>
      );
    }
    return null;
  };

// —— BLOCKED ADVANCE DAYS (default at least 1 day) ——
const effectiveAdv = Math.max(1, Number(listingData?.AdvanceDays || 0)); // default to 1 if null/0
const blocked = {};
for (let i = 0; i < effectiveAdv; i++) {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + i);
  const key =
    `${d.getFullYear()}-` +
    `${String(d.getMonth() + 1).padStart(2, '0')}-` +
    `${String(d.getDate()).padStart(2, '0')}`;

  blocked[key] = {
    disabled: true,
    disableTouchEvent: true,
    customStyles: {
      container: { backgroundColor: '#e1e1e1' }, // slightly darker grey
      text: { color: '#7a7a7a' },
    },
  };
}


  
  return (
<SafeAreaView style={styles.container}>
{isLoading ? (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="black" />
      </View>
    ) : listingData?.PauseLiveToggle === 'Pause' ? (
      <View style={styles.loadingContainer}>
        <Text style={{ textAlign: 'center', fontSize: 18 }}>
          This listing is currently paused.
        </Text>
      </View>
    ) : (
      <ScrollView
        style={{
          maxWidth: 600,
          width: '100%',
          alignSelf: 'center',
          flex: 1,
        }}
        contentContainerStyle={styles.contentContainer}
      >
  
  
        <View style={styles.bannerContainer}> 
          {/* Top Image: listingData.LogoImage */}
  
{/* Banner slider – single or multiple images */}
<FlatList
  ref={bannerListRef}
  data={bannerImages}
  horizontal
  pagingEnabled
  showsHorizontalScrollIndicator={false}
  keyExtractor={(u, i) => u + i}
  getItemLayout={(_, i) => ({
    length: BANNER_WIDTH,
    offset: BANNER_WIDTH * i,
    index: i,
  })}
  style={{ width: BANNER_WIDTH, height: BANNER_HEIGHT, alignSelf: 'center' }}
  renderItem={({ item }) => (
    <ShimmerPlaceHolder
      LinearGradient={LinearGradient}
      visible={bannerLoaded}
      shimmerColors={['#e0e0e0', '#f3f3f3', '#e0e0e0']}
      style={{ width: BANNER_WIDTH, height: BANNER_HEIGHT, borderRadius: 17 }}
    >
      <Image
        source={{ uri: item }}
        style={{ width: BANNER_WIDTH, height: BANNER_HEIGHT, borderRadius: 17 }}
        resizeMode="cover"
        onLoad={() => setBannerLoaded(true)}
        onError={() => setBannerLoaded(true)}
      />
    </ShimmerPlaceHolder>
  )}
/>

{/* Arrows + dots only show if >1 image */}
{bannerImages.length > 1 && (
  <>
    <TouchableOpacity style={styles.bannerArrowRight} onPress={nextBanner}>
      <Ionicons name="chevron-forward" size={20} color="#000" />
    </TouchableOpacity>

    <View style={styles.dotsWrap}>
      {bannerImages.map((_, i) => (
        <TouchableOpacity key={i} onPress={() => scrollTo(i)}>
          <View style={[styles.dot, i === bannerIndex && styles.dotActive]} />
        </TouchableOpacity>
      ))}
    </View>
  </>
)}

  
{bannerImages.length > 1 && ( <> {/* Left / Right arrows */} 
 <TouchableOpacity style={styles.bannerArrowRight} onPress={nextBanner} activeOpacity={0.8} hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }} > <Ionicons name="chevron-forward" size={20} color="#000" /> </TouchableOpacity> {/* Dots */} 
 
 
<View style={styles.dotsWrap}>
  {bannerImages.map((_, i) => (
    <TouchableOpacity key={i} onPress={() => scrollTo(i)} activeOpacity={0.8}>
      <View style={[styles.dot, i === bannerIndex && styles.dotActive]} />
    </TouchableOpacity>
  ))}
</View>


 </> )}

          <View style={styles.backContainer}>
            <TouchableOpacity style={styles.backButton} onPress={handleBackPress}>
              <Ionicons name="arrow-back" size={22} color="black" />
            </TouchableOpacity>
          </View>

          {/* Bottom Image: logoImage */}
          <View style={styles.logoContainer}>
  {logoImage ? (
    <Image
      source={{ uri: logoImage }}  // Use the logoImage state directly
      style={styles.logo}
      resizeMode="cover"
    />
  ) : null}

{bookedSlots.length > 0 && renderBookedSlots()}
</View>
        </View>

        <View style={styles.section}>
  <Text style={styles.headerSectionTitle}>
  {(listingData?.OnBehalfOf && listingData?.OnBehalfOf.trim() !== '') ? listingData.OnBehalfOf : listingData?.BrandName} Collab Offer
  <Text style={{ fontWeight: 'bold', color: '#FDF05D' }}>.</Text>
</Text>

       



<Modal
  animationType="fade"
  transparent={true}
  visible={successModalVisible}
  onRequestClose={() => setSuccessModalVisible(false)}
>
  <View style={styles.modalContainer}>
    <Animated.View
      style={[
        styles.successCard,
        styles.successCardRefined,
        engagementEmailData?.eligible &&
          engagementEmailData?.available &&
          styles.successCardEligible,
        { transform: [{ scale: scaleAnim }] }
      ]}
    >
      <TouchableOpacity
        style={styles.successCloseButton}
        onPress={handleCloseToCollabbayHome}
        hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
        activeOpacity={0.8}
      >
        <Ionicons name="close" size={20} color="#163B75" />
      </TouchableOpacity>

      <ScrollView
        style={styles.successScrollView}
        contentContainerStyle={styles.successScrollContent}
        showsVerticalScrollIndicator={false}
      >
        <Ionicons
          name="checkmark-circle"
          size={70}
          color="#2ecc71"
          style={{ marginBottom: 12 }}
        />

        {parseInt(listingData?.PointsEarned ?? 0) > 0 && (
          <View style={styles.rewardPill}>
            <Text style={styles.rewardPillText}>
              {parseInt(
                listingData?.PointsEarned ?? 0
              ).toLocaleString()} CƵ earned
            </Text>
          </View>
        )}

        <Text style={styles.successTitle}>
          Booking request sent
        </Text>

        <Text style={styles.successSubtitle}>
          If the venue approves, you’ll be notified. Otherwise, the request will expire.
        </Text>

        {engagementEmailData?.eligible &&
        engagementEmailData?.available ? (
          <>
            <View style={styles.successDivider} />

            <View style={styles.engagementModernCard}>
              <View style={styles.engagementHeaderRow}>
                <View style={styles.engagementMiniLabel}>
                  <Ionicons
                    name="stats-chart"
                    size={14}
                    color="#1D4ED8"
                    style={{ marginRight: 6 }}
                  />
                  <Text style={styles.engagementMiniLabelText}>
                    BOOST
                  </Text>
                </View>

                <View style={styles.engagementOptionalBadgeDark}>
                  <Text style={styles.engagementOptionalBadgeDarkText}>
                    OPTIONAL
                  </Text>
                </View>
              </View>

              <View style={styles.engagementHeadlineRow}>
                <View style={styles.engagementIconWrapBlue}>
                  <Ionicons
                    name="stats-chart"
                    size={22}
                    color="#1D4ED8"
                  />
                </View>

                <Text style={styles.engagementTitleGradient}>
                  Increase your chance of being accepted?
                </Text>
              </View>

              <Text style={styles.engagementBodyRefined}>
                We’ve already notified the venue. Sending a quick personal note can help your request stand out.
              </Text>

              <TouchableOpacity
                style={styles.emailVenueButtonRefined}
                onPress={handleEmailVenue}
                activeOpacity={0.85}
              >
                <Ionicons
                  name="paper-plane-outline"
                  size={18}
                  color="#111827"
                  style={{ marginRight: 10 }}
                />

                <Text style={styles.emailVenueButtonTextRefined}>
                  Email venue
                </Text>
              </TouchableOpacity>
            </View>
          </>
        ) : null}

        <TouchableOpacity
          style={styles.continueBrowsingPrimaryButton}
          onPress={handleContinueBrowsing}
          activeOpacity={0.88}
        >
          <Text style={styles.continueBrowsingPrimaryButtonText}>
            Continue browsing
          </Text>
        </TouchableOpacity>
      </ScrollView>
    </Animated.View>
  </View>
</Modal>






<Modal
  animationType="fade"
  transparent={true}
  visible={errorModalVisible}
  onRequestClose={() => setErrorModalVisible(false)}
>
  <View style={styles.modalContainer}>
    <View style={styles.modalContent}>
      <Ionicons name="alert-circle-outline" size={48} color="red" />
      <Text style={styles.modalText}>{errorMessage}</Text>
      <TouchableOpacity
        style={styles.modalButton}
        onPress={() => setErrorModalVisible(false)}
      >
        <Text style={styles.modalButtonText}>Close</Text>
      </TouchableOpacity>
    </View>
  </View>
</Modal>


{venueShots.length > 0 && (
  <>
    <View style={{ flexDirection: 'row', marginTop: 12, marginBottom: 12 }}>
    {venueShots.slice(0, 5).map((shot, idx) => {
  const isVideo = shot.Image?.endsWith('.mp4');
  return (
    <TouchableOpacity
      key={idx}
      style={{ marginRight: idx === venueShots.length - 1 ? 0 : 8 }}
      onPress={() => {
        setInitialSlide(idx);
        setShotsModalVisible(true);
      }}
    >


{isVideo ? (
  <>
    {!loadedThumbs[idx] && (
      <View
        style={{
          width: 48,
          height: 48,
          borderRadius: 10,
          backgroundColor: '#e5e5e5',
        }}
      />
    )}

    <video
      src={shot.Image}
      muted
      playsInline
      preload="auto"
      onLoadedData={() =>
        setLoadedThumbs(prev => ({ ...prev, [idx]: true }))
      }
      style={{
        display: loadedThumbs[idx] ? 'block' : 'none',
        width: 48,
        height: 48,
        borderRadius: 10,
        backgroundColor: '#000',
        objectFit: 'cover',
      }}
    />
  </>
) : (
  <>
    {!loadedThumbs[idx] && (
      <View
        style={{
          width: 48,
          height: 48,
          borderRadius: 10,
          backgroundColor: '#e5e5e5',
        }}
      />
    )}

    <Image
      source={{ uri: shot.Image }}
      onLoad={() =>
        setLoadedThumbs(prev => ({ ...prev, [idx]: true }))
      }
      style={{
        display: loadedThumbs[idx] ? 'flex' : 'none',
        width: 48,
        height: 48,
        borderRadius: 10,
        backgroundColor: '#000',
      }}
      resizeMode="cover"
    />
  </>
)}


    </TouchableOpacity>
  );
})}

    </View>

    <Modal
      visible={shotsModalVisible}
      transparent
      onRequestClose={() => setShotsModalVisible(false)}
    >
      <View style={{ flex: 1, backgroundColor: 'black' }}>
       <FlatList
  data={venueShots}
  horizontal
  pagingEnabled
  initialScrollIndex={initialSlide}
  getItemLayout={(_, i) => ({
    length: SCREEN_WIDTH,
    offset: SCREEN_WIDTH * i,
    index: i,
  })}
  keyExtractor={(_, i) => String(i)}
 renderItem={({ item }) => {
  const uri = item.Image || item.FileURL;
  const isVideo = uri?.endsWith('.mp4');



  return isVideo ? (
  <video
    src={uri}
    controls
    autoPlay
    playsInline
    preload="metadata"
    style={{
      width: SCREEN_WIDTH,
      height: Dimensions.get('window').height,
      objectFit: 'contain',
    }}
  />
) : (
  <Image
    source={{ uri }}
    style={{ width: SCREEN_WIDTH, height: Dimensions.get('window').height }}
    resizeMode="contain"
  />
);

}}

/>


        <TouchableOpacity
          onPress={() => setShotsModalVisible(false)}
          style={{
            position: 'absolute',
            top: 40,
            right: 20,
            zIndex: 999,
          }}
        >
          <Ionicons name="close-circle" size={36} color="white" />
        </TouchableOpacity>
      </View>
    </Modal>
  </>
)}


<View style={styles.section}>
  {minFollowersRequired && (
    <View style={styles.followersRequirementBox}>
      <Text style={styles.followersRequirementText}>{minFollowersRequired} followers required</Text>
    </View>
  )}



</View>

          {showWarning && (
  <View style={styles.warningCard}>
    <Ionicons name="warning-outline" size={24} color="black" />
    <Text style={styles.warningText}>
      Hey! Your account is under review. You will not be able to propose bookings until your account is verified. Keep an eye on your inbox.
    </Text>
  </View>
)}


<View style={[
  styles.urlContainer,
  {
    backgroundColor: '#f3f3f3',
    borderColor: '#f3f3f3',
    borderWidth: 1,
    borderRadius: 17,
    paddingHorizontal: 10,
    paddingVertical: 6,
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'flex-start', // allows wrapping nicely if content is multiline
    gap: 6,
    marginVertical: 8,
    maxWidth: '100%', // constrain container
    flexWrap: 'wrap', // ensure children can wrap
  }
]}>
  <Ionicons name="link" size={20} color="black" />
  <TouchableOpacity
    style={{ flexShrink: 1 }} // ensures Text doesn't overflow
    onPress={() => Linking.openURL(`https://${listingData?.BrandURL}`)}
  >
    <Text style={[styles.urlText, { flexShrink: 1, flexWrap: 'wrap' }]}>
      {listingData?.BrandURL}
    </Text>
  </TouchableOpacity>
</View>




          <View style={styles.descriptionBox}>
        
            <Text style={styles.description}>{listingData?.ListingDescription}</Text>
          </View>
          
       </View>

        <View style={styles.locationContainer}>
          <Ionicons name="location-sharp" size={20} color="black" />
          <Text style={styles.sectionTitleAddress}>{listingData?.Location}</Text>
        </View>



        <View style={styles.section}>

  {renderPreferredAvailability()}

</View>




        <View style={styles.locationContainer}>
          <Ionicons name="logo-instagram" size={20} color="black" />
          <Text style={styles.sectionTitleAddress}>Post Type : Reel</Text>
        </View>

        <View style={styles.locationContainer}>
  <Ionicons name="calendar" size={20} color="black" />
  <Text style={styles.sectionTitleAddress}>
    Turnaround Time: {listingData?.TurnAroundDays || 'N/A'} Days
  </Text>
</View>

        {/* Content Brief */}
        {renderContentBrief()}


        <View style={styles.offerUnifiedCard}>
  {/* Header */}
  <Text style={styles.offerMainTitle}>
    Offer <Ionicons name="gift-outline" size={24} color="black" />
  </Text>

  {/* Offer Content */}
  <View style={styles.offerHighlightBox}>
    <Text style={styles.offerHighlightText}>
      {listingData?.NonCreditOffer || 'N/A'}
    </Text>
  </View>

  {/* Offer Value Row with Info Icon */}
  <TouchableOpacity style={styles.offerValueRow} onPress={() => setShowInfoModal(true)}>
    <Ionicons name="wallet-outline" size={22} color="#000" style={{ marginRight: 10 }} />
    <View>
      <Text style={styles.offerValueLabel}>Offer Value</Text>
      <Text style={styles.offerValueAmount}>£{listingData?.Credits || 'N/A'}</Text>
    </View>
    <Ionicons name="information-circle-outline" size={20} color="#000" style={{ marginLeft: 'auto' }} />
  </TouchableOpacity>
</View>

{/* Offer Value Info Modal */}
<Modal
  animationType="fade"
  transparent={true}
  visible={showInfoModal}
  onRequestClose={() => setShowInfoModal(false)}
>
  <View style={styles.modalContainer}>
    <View style={styles.modalContent}>
      <Ionicons name="information-circle-outline" size={48} color="black" />
      <Text style={styles.modalText}>
        <Text style={{ fontWeight: 'bold' }}>What is the offer value?</Text>{"\n\n"}
        This is the estimated value of the goods/services included in the offer.
        {"\n\n"}Example: 2 comped mains worth £25 each = a £50 offer value.
        {"\n\n"}Note: This is not a cash payout, tab, or exact credit voucher unless stated so in the offer. The offer value is provided by the venue as a valuation based on the price of the comped goods. 
        {"\n\n"}When redeeming this collab, your order cannot exceed the offer value. 
      </Text>
      <TouchableOpacity style={styles.modalButton} onPress={() => setShowInfoModal(false)}>
        <Text style={styles.modalButtonText}>Makes Sense 👍</Text>
      </TouchableOpacity>
    </View>
  </View>
</Modal>


        {barterAllowed && (
  <View style={{ marginVertical: 16 }}>
    {!customOfferActive ? (
      <TouchableOpacity
        style={{
          borderColor: 'black',
          borderWidth: 1,
          borderRadius: 10,
          padding: 10,
          backgroundColor: 'white',
        }}
        onPress={() => setCustomOfferActive(true)}
      >
        <Text style={{ textAlign: 'center', fontWeight: 'bold' }}>or request a new offer</Text>
      </TouchableOpacity>
    ) : (
      <View style={{ padding: 10, backgroundColor: '#fff', borderColor: '#000', borderWidth: 1, borderRadius: 10 }}>
        <Text style={{ fontWeight: 'bold', marginBottom: 5 }}>Your Proposed Offer</Text>

        <View>
  <TextInput
    placeholder="What would you like the venue to offer you? i.e. 2 mains, sides and desserts"
    value={customNonCreditOffer}
    onChangeText={setCustomNonCreditOffer}
    maxLength={200}
    multiline
    style={{
      borderWidth: 1,
      borderColor: '#ccc',
      borderRadius: 8,
      padding: 10,
      marginBottom: 5,
      backgroundColor: '#f9f9f9',
    }}
  />
  <Text style={{ fontSize: 12, color: 'gray', textAlign: 'right', marginBottom: 10 }}>
    {customNonCreditOffer.length} / 200
  </Text>
</View>

<TextInput
  placeholder="Value of offer you'd like, i.e. £50"
  keyboardType="numeric"
  value={customCredits}
  onChangeText={setCustomCredits}
  style={{
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 8,
    padding: 10,
    backgroundColor: '#f9f9f9',
  }}
/>

      </View>
    )}
  </View>
)}



        <View style={styles.calendarContainer}>


<Calendar
  onDayPress={(day) => setSelectedDate(day.dateString)}
  markedDates={{
    ...blocked, // 👈 add this first
    [selectedDate]: { selected: true, selectedColor: '#FDF05D' },
  }}
  minDate={formatYMD(new Date())} // or keep your existing logic
  markingType="custom"
  renderArrow={(direction) => (
    <Ionicons
      name={direction === 'left' ? 'chevron-back' : 'chevron-forward'}
      size={24}
      color="black"
    />
  )}
  theme={{
    todayTextColor: '#FDF05D',
    selectedDayBackgroundColor: '#FDF05D',
    selectedDayTextColor: 'black',
  }}
/>

        </View>



<View style={styles.timePickerContainer}>
  <Text style={styles.timePickerLabel}>Select Time</Text>
  <ScrollView style={styles.timeScrollView}>
    {Array.from({ length: 40 }, (_, i) => {
      const hour = Math.floor((i + 14) / 2) % 24; // Shift to start at 7:00 AM
      const minute = (i % 2) === 0 ? '00' : '30';
      const ampm = hour >= 12 && hour < 24 ? 'PM' : 'AM';
      const adjustedHour = hour % 12 === 0 ? 12 : hour % 12; // Convert hour to 12-hour format
      const timeLabel = `${adjustedHour}:${minute} ${ampm}`;

      return (
        <TouchableOpacity
          key={i}
          style={[
            styles.timeSlot,
            selectedTime === timeLabel && styles.selectedTimeSlot
          ]}
          onPress={() => setSelectedTime(timeLabel)}
        >
          <Text>{timeLabel}</Text>
        </TouchableOpacity>
      );
    })}
  </ScrollView>
</View>



{additionalDetailsRequired && (
  <View style={styles.additionalDetailsCard}>
    <Text style={styles.cardTitle}>Additional Details</Text>
    <TextInput
      style={styles.inputField}
      placeholder="First Name"
      value={creatorFirstName}
      onChangeText={setCreatorFirstName}
    />
    <TextInput
      style={styles.inputField}
      placeholder="Last Name"
      value={creatorLastName}
      onChangeText={setCreatorLastName}
    />
    <TextInput
      style={styles.inputField}
      placeholder="Phone Number"
      keyboardType="phone-pad"
      value={creatorPhoneNumber}
      onChangeText={(text) => {
        // Basic validation to only allow numbers
        if (/^\d*$/.test(text)) setCreatorPhoneNumber(text);
      }}
    />
  </View>
)}

        <View style={styles.messageInput}>
          <Text style={styles.messageInputTitle}>  <Ionicons name="chatbubble-ellipses" size={20} color="black" /> Add a Message</Text>
          <TextInput
            style={styles.messageBoxInput}
            placeholder="Type your message here"
            multiline
            value={message}
            onChangeText={setMessage}
            maxLength={170}
          />
           <Text style={styles.charCounter}>
            {message.length} / 170
        </Text>
        </View>

        <View style={styles.visitorInputContainer}>
          <Text style={styles.visitorInputLabel}>Additional Visitors?</Text>
          <Text style={styles.plusOneLabel}>Note | Plus ones are not directly included in collabbay offers. However, let the brand know if you wish to bring plus-ones and they can advise at their discretion.</Text>
      
          <View style={styles.visitorOptions}>
            <TouchableOpacity onPress={() => setAddedVisitors(0)}>
              <Text style={[styles.visitorOption, addedVisitors === 0 && styles.selectedVisitorOption]}>0</Text>
            </TouchableOpacity>
            {Array.from({ length: 5 }, (_, i) => (
              <TouchableOpacity key={i + 1} onPress={() => setAddedVisitors(i + 1)}>
                <Text style={[styles.visitorOption, addedVisitors === i + 1 && styles.selectedVisitorOption]}>+{i + 1}</Text>
              </TouchableOpacity>
            ))}
          </View>
         
        </View>

    {!showWarning ? (
  <TouchableOpacity
    style={[styles.collabButton, isSubmitting && { opacity: 0.6 }]}
    onPress={handleCollabPress}
    disabled={isSubmitting}
  >
    <Text style={styles.collabButtonText}>
      {isSubmitting ? 'Submitting...' : 'Submit Collab Request'}
    </Text>

    {/* ➕ always show earnable CZ */}
    <Text style={{ fontSize: 13, color: '#555', marginTop: 4 }}>
      Earn +{parseInt(listingData?.PointsEarned ?? 0).toLocaleString()} CƵ 🪙
    </Text>
  </TouchableOpacity>
) : (
  <View style={styles.verificationCard}>
    <Ionicons name="shield-checkmark-outline" size={28} color="black" />
    <Text style={styles.verificationText}>
      Your account is being run through our verification process. Hang tight...
    </Text>
    <Text
      style={[
        styles.verificationText,
        { fontWeight: 'normal', fontSize: 14, marginTop: 6 }
      ]}
    >
      You'll be notified if verified. In the meantime, update your profile. Welcome!
    </Text>
    <ActivityIndicator size="small" color="black" style={{ marginTop: 10 }} />
  </View>
)}

      </ScrollView>
       )}


{/* ---------- EXIT-SURVEY MODAL ---------- */}
<Modal
  animationType="fade"
  transparent
  visible={exitSurveyVisible}
  onRequestClose={() => {
    clearInterval(timerRef.current);
    setExitSurveyVisible(false);
    navigation.goBack();
  }}
>
  <View style={styles.modalContainer}>
    <View style={[styles.modalContent, { paddingVertical: 30 }]}>
      <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 6 }}>
        Quick one – why didn’t you book?
      </Text>
      <Text style={{ fontSize: 12, fontWeight: 'bold', marginBottom: 16 }}>
        Update your preferences.
      </Text>

      {/* answer buttons */}
      {exitReasons.map((r) => (
        <TouchableOpacity
          key={r.id}
          onPress={() => {
            setSelectedExitReason(r.id);
         
            sendExitSurvey(r.label);

          }}
          style={{
            width: '100%',
            paddingVertical: 14,
            paddingHorizontal: 12,
            borderRadius: 12,
            borderWidth: 1,
            borderColor: '#ddd',
            backgroundColor: selectedExitReason === r.id ? '#FDF05D' : '#fff',
            marginBottom: 10,
          }}
        >
          <Text style={{ textAlign: 'center' }}>{r.label}</Text>
        </TouchableOpacity>
      ))}

      {/* progress bar 0 → 4 s  (fills right-to-left) */}
      <View
        style={{
          width: '100%',
          height: 8,
          backgroundColor: '#eee',
          borderRadius: 20,
          overflow: 'hidden',
          marginTop: 6,
        }}
      >
        <View
          style={{
            height: '100%',
            width: `${(4 - countdown) / 4 * 100}%`,
            backgroundColor: '#FDF05D',
            alignSelf: 'flex-start',
          }}
        />
      </View>

{/* skip */}
<TouchableOpacity
  disabled={!canSkip}
  style={{
    marginTop: 12,
    opacity: canSkip ? 1 : 0.4,
  }}
  onPress={() => {
    if (!canSkip) return;
    clearInterval(timerRef.current);
    setExitSurveyVisible(false);
    navigation.goBack();
  }}
>
  <Text style={{ fontSize: 16, textDecorationLine: 'underline' }}>
    {canSkip ? 'Skip' : `Skip (${countdown})`}
  </Text>
</TouchableOpacity>

    </View>
  </View>
</Modal>
{/* ---------- /EXIT-SURVEY MODAL ---------- */}




    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',

  },
  contentContainer: {
    paddingHorizontal: 16,
    marginTop: 20,
  },
  bannerContainer: {
    position: 'relative',
    marginBottom: 16,
    marginTop: 12,
  },
  bannerImage: {
    width: '100%',
    height: 190,
  borderRadius: 20,
  },
  backContainer: {
    position: 'absolute',
    top: 12,
    left: 16,
  },
  backButton: {
    backgroundColor: 'white',
    borderRadius: 30,
    padding: 8,
    alignItems: 'center',
    justifyContent: 'center',
    width: 33,
    height: 33,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
    elevation: 3,
  },  
  logo: {
    width: 100,
    height: 100,
    borderRadius: 50,
    marginLeft: 12,
    marginBottom: 15,
    borderColor: '#000',
    borderWidth: 2,
    backgroundColor: '#000',
  },
  section: {
    marginBottom: 16,
  },
  headerSectionTitle: {
    fontSize: 22,
    fontWeight: 'bold',
  },
  descriptionBox: {
    backgroundColor: '#f0f0f0',
    borderRadius: 10,
    padding: 10,
    marginTop: 8,
  },
  description: {
    fontSize: 16,
    color: '#666',
  },
  locationContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginLeft: 8,
  },
  sectionTitleAddress: {
    fontSize: 16,
    marginLeft: 8,
  },
  creditsCard: {
    backgroundColor: '#FDF05D',
    padding: 16,
    borderRadius: 10,
    marginBottom: 16,
    alignItems: 'center',
  },
  creditsCardTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: 8,
  },
  creditsCardSubTitle: {
    fontSize: 16,
  },
  calendarContainer: {
    marginBottom: 16,
  },
  bookedSlotsContainer: {
    marginBottom: 16,
    backgroundColor: '#f0f0f0',
    borderRadius: 10,
    padding: 10,
  },
  bookedSlotsTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  bookedSlotsBody: {
    fontSize: 10,
    marginBottom: 8,
  },
  bookedSlot: {
    marginBottom: 4,
  },
  bookedSlotText: {
    fontSize: 16,
  },
  expandButton: {
    marginTop: 8,
    flexDirection: 'row',
    // alignItems: 'center',
  },
  expandButtonText: {
    color: '#007BFF',
    fontSize: 16,
    textDecorationLine: 'underline',
    marginLeft: 4,
  },
  timePickerContainer: {
    marginBottom: 16,
  },
  timePickerLabel: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  plusOneLabel: {
    fontSize: 10,
    marginBottom: 5,
    marginTop: 5,
  },
  timeScrollView: {
    height: 120,
  },
  timeSlot: {
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderColor: '#eee',
  },
  selectedTimeSlot: {
    backgroundColor: '#FDF05D',
  },
  messageInput: {
    marginBottom: 16,
  },
  messageInputTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  messageBoxInput: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 8,
    padding: 10,
    fontSize: 16,
    backgroundColor: '#f0f0f0',
  },
  collabButton: {
    backgroundColor: '#FDF05D',
    paddingVertical: 14,
    borderRadius: 16,
    borderColor: '#fdf05d',
    alignItems: 'center',
    marginBottom: 30,
    borderWidth: 1,
  },
  collabButtonText: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  contentBriefContainer: {
    padding: 15,
    borderRadius: 10,
    borderColor: '#ddd',
    borderWidth: 1,
    marginVertical: 10,
  },
  bulletPoint: {
    fontSize: 16,
    color: '#333',
  },
  urlContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 10,
    padding: 5,
    marginVertical: 3,
  },
  urlText: {
    marginLeft: 8,
    fontSize: 16,
    color: 'black',
    textDecorationLine: 'underline',
  },
  logoContainer: { 
    position: 'absolute',
    top: 32,
    right: 0, 
    zIndex: 1,
    marginBottom: 16,
    marginTop: 64,
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%', 
},
visitorInputContainer: {
  marginBottom: 16,
  padding: 10,
  backgroundColor: '#f0f0f0',
  borderRadius: 10,
},
visitorInputLabel: {
  fontSize: 14,
  fontWeight: 'bold',
  marginBottom: 8,
},
visitorOptions: {
  flexDirection: 'row',
  justifyContent: 'space-around',
},
visitorOption: {
  fontSize: 16,
  paddingVertical: 10,
  paddingHorizontal: 20,
  borderRadius: 10,
},
selectedVisitorOption: {
  backgroundColor: '#FDF05D',
},
warningCard: {
  backgroundColor: '#f0f0f0',
  padding: 16,
  borderRadius: 25,
  borderWidth: 1,
  borderColor: 'darkgrey',
  flexDirection: 'row',
  alignItems: 'center',
  marginVertical: 16,
},
warningText: {
  fontSize: 14,
  color: 'black',
  marginLeft: 10,
  flexShrink: 1,
},
sectionTitleAddress: {
  fontSize: 16,
  marginLeft: 8,
},
availabilityContainer: {
  marginTop: 16,
  padding: 12,
},
availabilityHeader: {
  fontSize: 18,
  fontWeight: 'bold',
  marginBottom: 8,
  color: '#333',
},
availabilityList: {
  flexDirection: 'row',
  flexWrap: 'wrap', // Allows items to wrap if necessary
  gap: 8,
},
availabilityItem: {
  backgroundColor: '#f0f0f0', // Light gray background
  paddingVertical: 8,
  paddingHorizontal: 12,
  borderRadius: 16,
  marginBottom: 8,
},
availabilityText: {
  fontSize: 14,
  color: '#333',
  textAlign: 'center',
},
noAvailabilityText: {
  fontSize: 14,
  fontStyle: 'italic',
  color: '#999',
  textAlign: 'center',
},
charCounter: {
  fontSize: 12,
  color: 'gray',
  textAlign: 'right',
  marginTop: 5,
},
verificationCard: {
  backgroundColor: '#f0f0f0',
  padding: 16,
  borderRadius: 16,
  borderWidth: 1,
  borderColor: 'darkgrey',
  alignItems: 'center',
  justifyContent: 'center',
  marginVertical: 16,
},
verificationText: {
  fontSize: 16,
  fontWeight: 'bold',
  color: '#333',
  textAlign: 'center',
  marginTop: 10,
},
modalContainer: {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
},
modalContent: {
  width: '80%',
  padding: 20,
  backgroundColor: 'white',
  borderRadius: 10,
  alignItems: 'center',
},
modalText: {
  fontSize: 18,
  textAlign: 'center',
  marginVertical: 10,
},
modalButton: {
  marginTop: 15,
  backgroundColor: '#FDF05D',
  padding: 10,
  borderRadius: 5,
},
modalButtonText: {
  fontSize: 16,
  fontWeight: 'bold',
  textAlign: 'center',
},
loadingContainer: {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#fff',
},
additionalDetailsCard: {
  backgroundColor: '#f3f3f3',
  padding: 16,
  borderRadius: 15,
  marginBottom: 16,
},
cardTitle: {
  fontSize: 18,
  fontWeight: 'bold',
  marginBottom: 10,
},
inputField: {
  borderWidth: 1,
  borderColor: '#ccc',
  borderRadius: 8,
  padding: 12,
  marginBottom: 10,
  backgroundColor: '#fff',
  fontSize: 16,
},
offerUnifiedCard: {
  backgroundColor: '#f3f3f3',
  borderRadius: 16,
  padding: 16,
  marginBottom: 24,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 1 },
  shadowOpacity: 0.05,
  shadowRadius: 3,
  elevation: 2,
},

offerMainTitle: {
  fontSize: 20,
  fontWeight: 'bold',
  color: '#000',
  marginBottom: 14,
  flexDirection: 'row',
  alignItems: 'center',
},

offerHighlightBox: {
  backgroundColor: '#FDF05D',
  borderRadius: 12,
  padding: 14,
  marginBottom: 12,
},

offerHighlightText: {
  fontSize: 16,
  color: '#333',
  lineHeight: 22,
},

offerValueRow: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#fff',
  padding: 12,
  borderRadius: 10,
  borderColor: '#ddd',
  borderWidth: 1,
},

offerValueLabel: {
  fontSize: 14,
  color: '#555',
  marginBottom: 2,
  fontWeight: '500',
},

offerValueAmount: {
  fontSize: 14,
  fontWeight: 'bold',
  color: '#000',
},

modalContainer: {
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
},

modalContent: {
  width: '85%',
  backgroundColor: 'white',
  padding: 20,
  borderRadius: 12,
  alignItems: 'center',
},

modalText: {
  fontSize: 16,
  textAlign: 'center',
  color: '#333',
  marginTop: 12,
  marginBottom: 20,
  lineHeight: 22,
},

modalButton: {
  backgroundColor: '#FDF05D',
  paddingHorizontal: 20,
  paddingVertical: 10,
  borderRadius: 8,
},

modalButtonText: {
  fontSize: 16,
  fontWeight: 'bold',
  color: '#000',
},
successCard: {
  width: '85%',
  backgroundColor: 'white',
  padding: 24,
  borderRadius: 20,
  alignItems: 'center',
  shadowColor: '#000',
  shadowOpacity: 0.15,
  shadowOffset: { width: 0, height: 4 },
  shadowRadius: 10,
  elevation: 6,
},
successTitle: {
  fontSize: 22,
  fontWeight: 'bold',
  textAlign: 'center',
  marginTop: 8,
},
successSubtitle: {
  fontSize: 14,
  color: '#555',
  textAlign: 'center',
  marginTop: 6,
  marginBottom: 18,
  lineHeight: 20,
},
successButton: {
  backgroundColor: '#FDF05D',
  paddingHorizontal: 24,
  paddingVertical: 12,
  borderRadius: 10,
},
successButtonText: {
  fontSize: 16,
  fontWeight: 'bold',
  color: '#000',
},
successCardRefined: {
  width: '92%',
  maxWidth: 460,
  maxHeight: '88%',
  backgroundColor: '#FFFFFF',
  borderRadius: 28,
  paddingTop: 24,
  paddingBottom: 22,
  paddingHorizontal: 22,
  borderWidth: 1,
  borderColor: '#E5EAF2',
  shadowColor: '#000',
  shadowOpacity: 0.10,
  shadowOffset: { width: 0, height: 10 },
  shadowRadius: 22,
  elevation: 8,
},

successCardEligible: {
  width: '92%',
  maxWidth: 460,
  maxHeight: '88%',
},

successCloseButton: {
  position: 'absolute',
  top: 15,
  right: 15,
  width: 38,
  height: 38,
  borderRadius: 19,
  backgroundColor: '#F7F9FC',
  borderWidth: 1,
  borderColor: '#DCE6F5',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 20,
},

successScrollView: {
  width: '100%',
},

successScrollContent: {
  alignItems: 'center',
  paddingTop: 7,
  paddingBottom: 3,
},

successDivider: {
  width: '100%',
  height: 1,
  backgroundColor: '#E6EAF0',
  marginTop: 19,
  marginBottom: 19,
},

engagementModernCard: {
  width: '100%',
  backgroundColor: '#F1F7FF',
  borderWidth: 1.5,
  borderColor: '#8BB9F7',
  borderRadius: 22,
  padding: 18,

  shadowColor: '#2563EB',
  shadowOpacity: 0.08,
  shadowOffset: { width: 0, height: 5 },
  shadowRadius: 14,
  elevation: 3,
},

engagementHeaderRow: {
  width: '100%',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 15,
},

engagementMiniLabel: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#DCEBFF',
  borderRadius: 999,
  paddingHorizontal: 10,
  paddingVertical: 6,
},

engagementMiniLabelText: {
  fontSize: 11,
  fontWeight: '800',
  color: '#1D4ED8',
  letterSpacing: 0.5,
},

engagementOptionalBadgeDark: {
  backgroundColor: '#164B91',
  borderRadius: 999,
  paddingHorizontal: 12,
  paddingVertical: 6,
},

engagementOptionalBadgeDarkText: {
  fontSize: 10,
  fontWeight: '800',
  color: '#FFFFFF',
  letterSpacing: 0.8,
},

engagementHeadlineRow: {
  width: '100%',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 11,
},

engagementIconWrapBlue: {
  width: 45,
  height: 45,
  borderRadius: 14,
  backgroundColor: '#DCEBFF',
  borderWidth: 1,
  borderColor: '#A9CBFA',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 12,
},

engagementTitleGradient: {
  flex: 1,
  fontSize: 21,
  lineHeight: 26,
  fontWeight: '800',
  letterSpacing: -0.4,
  color: '#1755B5',

  textShadowColor: 'rgba(69, 139, 240, 0.30)',
  textShadowOffset: { width: 1, height: 1 },
  textShadowRadius: 7,
},

engagementBodyRefined: {
  width: '100%',
  fontSize: 14,
  lineHeight: 21,
  color: '#46617F',
  marginBottom: 16,
},

emailVenueButtonRefined: {
  width: '100%',
  minHeight: 54,
  backgroundColor: '#FFFFFF',
  borderWidth: 1,
  borderColor: '#C9D8ED',
  borderRadius: 15,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',

  shadowColor: '#143A6C',
  shadowOpacity: 0.06,
  shadowOffset: { width: 0, height: 4 },
  shadowRadius: 10,
  elevation: 2,
},

emailVenueButtonTextRefined: {
  fontSize: 16,
  fontWeight: '750',
  color: '#152238',
},

continueBrowsingPrimaryButton: {
  width: '100%',
  minHeight: 58,
  backgroundColor: '#111827',
  borderRadius: 16,
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: 20,

  shadowColor: '#000',
  shadowOpacity: 0.14,
  shadowOffset: { width: 0, height: 7 },
  shadowRadius: 13,
  elevation: 4,
},

continueBrowsingPrimaryButtonText: {
  fontSize: 16,
  fontWeight: '800',
  color: '#FFFFFF',
  letterSpacing: 0.1,
},
rewardPill: {
  backgroundColor: '#2ecc71',
  paddingHorizontal: 12,
  paddingVertical: 4,
  borderRadius: 50,
  marginBottom: 10,
},
rewardPillText: {
  color: 'white',
  fontSize: 13,
  fontWeight: 'bold',
},


bannerArrowLeft: {
  position: 'absolute',
  top: '50%',
  left: 10,
  transform: [{ translateY: -18 }],
  width: 36,
  height: 36,
  borderRadius: 18,
  backgroundColor: 'rgba(255,255,255,0.95)',
  borderWidth: 1,
  borderColor: '#e8e8e8',
  justifyContent: 'center',
  alignItems: 'center',
  shadowColor: '#000',
  shadowOpacity: 0.08,
  shadowOffset: { width: 0, height: 2 },
  shadowRadius: 4,
  elevation: 2,
},
bannerArrowRight: {
  position: 'absolute',
  top: '50%',
  right: 10,
  transform: [{ translateY: -18 }],
  width: 36,
  height: 36,
  borderRadius: 18,
  backgroundColor: 'rgba(255,255,255,0.95)',
  borderWidth: 1,
  borderColor: '#e8e8e8',
  justifyContent: 'center',
  alignItems: 'center',
  shadowColor: '#000',
  shadowOpacity: 0.08,
  shadowOffset: { width: 0, height: 2 },
  shadowRadius: 4,
  elevation: 2,
},
dotsWrap: {
  position: 'absolute',
  bottom: 8,
  left: 0,
  right: 0,
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
},
dot: {
  width: 6,
  height: 6,
  borderRadius: 3,
  backgroundColor: 'rgba(0,0,0,0.25)',
  marginHorizontal: 3,
},
dotActive: {
  width: 14,
  borderRadius: 7,
  backgroundColor: '#000',
},



});

export default CreateSubmissionPage;
